"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgLifeBuoy = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M24 13c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11 4.925-11 11-11zm-9 11a9 9 0 0014.617 7.032l-2.86-2.86a5 5 0 01-6.929-6.929l-2.86-2.86A8.962 8.962 0 0015 24zm9-9a8.962 8.962 0 00-5.617 1.968l2.86 2.86a5 5 0 016.929 6.929l2.86 2.86A9 9 0 0024 15zm0 6a3 3 0 100 6 3 3 0 000-6zm-2.123 5.123a1 1 0 010 1.414l-4.24 4.24a1 1 0 01-1.414-1.414l4.24-4.24a1 1 0 011.414 0zm9.19-9.19a1 1 0 010 1.414l-3.53 3.53a1 1 0 01-1.414-1.414l3.53-3.53a1 1 0 011.414 0z",
    id: "life-buoy_svg__a"
  }));
};

var _default = SvgLifeBuoy;
exports.default = _default;